/**
 * Header Cart functionality
 * Handles mini-cart dropdown interactions
 */

const headerCart = {
	/**
	 * Initialize cart functionality
	 */
	init() {
		this.bindEvents();
	},

	/**
	 * Bind cart-related events
	 */
	bindEvents() {
		// Currently no cart-specific events needed
		// Cart button simply navigates to cart page
	},

	/**
	 * Update cart count (called when cart is updated via AJAX)
	 *
	 * @param {number} count
	 */
	updateCartCount(count) {
		const cartContainer = document.querySelector('.main-header__cart');
		const cartCount = document.querySelector('.cart-count');
		
		if (count > 0) {
			if (cartCount) {
				cartCount.textContent = count;
			}
			if (cartContainer) {
				cartContainer.style.display = 'flex';
			}
		} else if (cartContainer) {
			// Hide cart icon if no items
			cartContainer.style.display = 'none';
		}
	}
};

export default headerCart;